<template>
  <div class="admin-session-material-changes">
    <div class="overline grey--text mb-3">
      Modifications du tableau de matériel ({{ changes.length }})
    </div>
    <v-alert v-if="!changes.length" type="info" dense text>
      Aucune modification du tableau de matériel sur ce projet.
    </v-alert>
    <v-simple-table v-else dense>
      <thead>
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Besoin</th>
          <th>Avant</th>
          <th>Après</th>
          <th>Par</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in changes" :key="c.id">
          <td class="text-no-wrap">{{ formatDate(c.created_at) }}</td>
          <td>
            <v-chip x-small label :color="actionMeta(c.action).color" text-color="white">
              {{ actionMeta(c.action).label }}
            </v-chip>
            <div v-if="sourceLabel(c.source)" class="caption grey--text">{{ sourceLabel(c.source) }}</div>
          </td>
          <td>{{ need(c) }}</td>
          <td>
            <template v-if="c.before">
              <div>{{ c.before.commercial_designation || '—' }}</div>
              <div class="caption grey--text">
                <span v-if="c.before.code_article">{{ c.before.code_article }} · </span>
                {{ statusLabel(c.before.match_status) }}
                <span v-if="c.before.match_score != null"> ({{ c.before.match_score }}%)</span>
              </div>
            </template>
            <span v-else>—</span>
          </td>
          <td>
            <template v-if="c.after">
              <div>{{ c.after.commercial_designation || '—' }}</div>
              <div class="caption grey--text">
                <span v-if="c.after.code_article">{{ c.after.code_article }}</span>
              </div>
            </template>
            <span v-else>—</span>
          </td>
          <td>{{ c.user || '—' }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
const ACTIONS = {
  add: { label: 'Ajout', color: 'success' },
  remove: { label: 'Suppression', color: 'error' },
  substitute: { label: 'Substitution', color: 'primary' },
}
const SOURCES = {
  suggestion: 'Recherche de stock',
  option: 'Option appliquée',
  alternative: 'Alternative choisie',
}
const STATUS_LABELS = {
  matched: 'En stock',
  ambiguous: 'À confirmer',
  hors_stock: 'Hors stock',
  manual: 'Choix manuel',
}

export default {
  name: 'AdminSessionMaterialChanges',
  props: {
    changes: { type: Array, default: () => [] },
  },
  methods: {
    actionMeta(action) {
      return ACTIONS[action] || { label: action, color: 'grey' }
    },
    sourceLabel(source) {
      return SOURCES[source] || ''
    },
    statusLabel(status) {
      return STATUS_LABELS[status] || 'Sans correspondance'
    },
    // The need the line answers: the brief's request, else its current designation.
    need(change) {
      const line = change.before || change.after || {}
      return line.requested_designation || line.commercial_designation || '—'
    },
    formatDate(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' })
    },
  },
}
</script>
